<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button ionBackButton (click)="onDismiss()">
        <ion-icon src="/assets/icon/back-icon-dark.svg"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>
      @if (studentForename) {
        Payment Request for {{ studentForename }}
      } @else {
        Payment Request
      }

    </ion-title>
  </ion-toolbar>
</ion-header>
@if (updateRequired) {
  <ion-content>
    <div class="errorCont">
      <div class="retryErrorCont">
        <p class="explainerText ion-text-center">
          Your Payment Requests have been moved to a new area of the app called Slips.
        </p>
        <p class="explainerText ion-text-center">
          To view your slips, please close this page and tap <b>Schools > <i>student name</i> > View response slips</b>
        </p>
      </div>
    </div>
  </ion-content>
} @else {
  @if (vm$ | async; as vm) {
    <ion-content>
      @if (vm.paymentViewModel && !vm.emptyTemplate) {
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
      } @else {
        <div class="noItemTemplate">
          @switch (vm.emptyTemplate) {
            @case ('firstLoadError') {
              <div class="firstLoadErrorTemplateCont">
                <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
              </div>
            }
            @case ('firstLoad') {
              <div class="firstLoadTemplateCont">
                <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
              </div>
            }
          }
        </div>
      }
      <ng-template #itemTemplate>
        <ion-grid class="ion-no-padding" fixed>
          <div class="title">
            <div class="content">{{ vm.paymentViewModel.title }}</div>
            <hr />
          </div>
          <div class="totalAmount">
            <div class="content">
              <span class="legend">Total Amount</span>
              <span class="value">
                <span class="pounds">£{{ getPounds(vm.payment.amount) }}</span>
                <span class="pences">.{{ getPences(vm.payment.amount) }}</span>
              </span>
            </div>
            <hr />
          </div>
          <div class="stillToPay">
            <div class="content">
              <span class="legend">Still to Pay</span>
              <span
                class="value"
                [class.grey]="noIntentMessageCode === 'PaymentNotActive'"
                [class.paymentBeingConfirmedCont]="vm.payment.paymentBeingConfirmed">
                @if (vm.payment.paymentBeingConfirmed) {
                  <div class="pendingPaymentLabel">
                    PENDING
                  </div>
                } @else {
                  @if (isNegative(vm.payment.balance)) {
                    <div class="negativeTemplate">
                      <span class="pounds">(£{{ getPounds(vm.payment.balance) }}</span>
                      <span class="pences">.{{ getPences(vm.payment.balance) }})</span>
                    </div>
                  } @else {
                    <span class="pounds">£{{ getPounds(vm.payment.balance) }}</span>
                    <span class="pences">.{{ getPences(vm.payment.balance) }}</span>
                  }
                }
              </span>
            </div>
            <hr />
          </div>
          <div class="dueDate">
            <div class="content">
              <span class="legend">Due Date</span>
              <span
                class="value"
                [class]="getNoIntentMessageClass()"
                [class.overdue]="isOverdue(vm.paymentViewModel.dueOn, vm.paymentViewModel)"
                [class.dash]="!vm.paymentViewModel.dueOn">
                {{ vm.paymentViewModel.dueOn ? (vm.paymentViewModel.dueOn | amDateFormat: 'DD MMM YY') : '-' }}
              </span>
            </div>
            <hr />
          </div>
          @if (paymentIntentLoading) {
            <div class="paymentIntentLoading">
              <ion-spinner name="crescent"></ion-spinner>
            </div>
          }
          @if (!paymentIntentLoading && !noIntentMessage && native && viewModel$ | async; as viewModel) {
            <div>
              @switch (vm.paymentViewModel.status) {
                @case (paymentStatus.Active) {
                  <div
                    class="paymentStateContainer"
                    [class.card]="viewModel.state !== PaymentState.Initialised"
                    >
                    @switch (viewModel.state) {
                      @case (PaymentState.Initialised) {
                        <div class="paymentContainer">
                          <app-student-payment-form-native
                            [viewModel]="viewModel"
                            (applePayment)="onPayWithApplePay($event, vm.payment)"
                            (googlePayment)="onPayWithGooglePay($event, vm.payment)"
                            (chooseMethod)="onChooseMethod($event)"
                            (confirm)="onConfirm($event, vm.payment)"
                            (editAmount)="onEditAmount($event, vm.payment)">
                          </app-student-payment-form-native>
                        </div>
                      }
                      @case (PaymentState.ProcessingPayment) {
                        <span class="processingPayment">
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <ion-spinner name="crescent"></ion-spinner>
                            </div>
                            <div class="textCont">
                              <p class="header">Processing payment</p>
                              <p class="subHeader">PLEASE WAIT</p>
                            </div>
                          </div>
                        </span>
                      }
                      @case (PaymentState.ConfirmingPayment) {
                        <span class="paymentSuccess" [@slideUpFadeInWithChild]>
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <img src="/assets/icon/tick-icon-green.svg" />
                            </div>
                            <div class="textCont">
                              @if (paidWithGooglePay) {
                                <p class="header">
                                  Success! Paid with Google Pay.
                                </p>
                              } @else {
                                <p class="header">Payment success!</p>
                              }
                              <p class="subHeader" [@delayedSlideUpFadeIn]>
                                <ion-spinner name="crescent"></ion-spinner> CONFIRMATION PENDING
                              </p>
                            </div>
                          </div>
                        </span>
                      }
                      @case (PaymentState.PaymentConfirmed) {
                        <span class="paymentConfirmed" [@slideUpFadeIn]>
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <img src="/assets/icon/tick-icon-green.svg" />
                            </div>
                            <div class="textCont">
                              <p class="header">Payment confirmed!</p>
                              @if (paidWithGooglePay) {
                                <p class="header">Paid with Google Pay</p>
                              }
                              <p class="subHeader" [@delayedSlideUpFadeIn]>WE'VE EMAILED YOU A RECEIPT</p>
                            </div>
                          </div>
                        </span>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
          @if (!paymentIntentLoading && !noIntentMessage && !native && viewModel$ | async; as viewModel) {
            <ion-card>
              @switch (vm.paymentViewModel.status) {
                @case (paymentStatus.Active) {
                  <div class="paymentStateContainer">
                    @switch (viewModel.state) {
                      @case (PaymentState.Initialised) {
                        <span class="paymentContainer">
                          @if (viewModel.intent) {
                            <app-student-payment-form
                              [paymentKey]="paymentKey"
                              [intentSecret]="viewModel.intent.intentSecretKey"
                              [payment]="vm.payment"
                              (paymentComplete)="onPaymentComplete(viewModel)">
                            </app-student-payment-form>
                          }
                        </span>
                      }
                      @case (PaymentState.ProcessingPayment) {
                        <span class="processingPayment">
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <ion-spinner name="crescent"></ion-spinner>
                            </div>
                            <div class="textCont">
                              <p class="header">Processing payment</p>
                              <p class="subHeader">PLEASE WAIT</p>
                            </div>
                          </div>
                        </span>
                      }
                      @case (PaymentState.ConfirmingPayment) {
                        <span class="paymentSuccess" [@slideUpFadeInWithChild]>
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <img src="/assets/icon/tick-icon-green.svg" />
                            </div>
                            <div class="textCont">
                              <p class="header">Payment success!</p>
                              <p class="subHeader" [@delayedSlideUpFadeIn]>
                                <ion-spinner name="crescent"></ion-spinner> CONFIRMATION PENDING
                              </p>
                            </div>
                          </div>
                        </span>
                      }
                      @case (PaymentState.PaymentConfirmed) {
                        <span class="paymentConfirmed" [@slideUpFadeIn]>
                          <div class="contentWrapper">
                            <div class="imageSpinnerCont">
                              <img src="/assets/icon/tick-icon-green.svg" />
                            </div>
                            <div class="textCont">
                              <p class="header">Payment confirmed!</p>
                              <p class="subHeader" [@delayedSlideUpFadeIn]>WE'VE EMAILED YOU A RECEIPT</p>
                            </div>
                          </div>
                        </span>
                      }
                    }
                  </div>
                }
              }
            </ion-card>
          }
          @if (noIntentMessage) {
            <div class="intentMessageCont">
              <div class="intentMessageContInner" [class]="getNoIntentMessageClass()">
                @if (getNoIntentMessageIcon()) {
                  <ion-icon [src]="getNoIntentMessageIcon()"></ion-icon>
                }
                <p>{{ noIntentMessage }}</p>
              </div>
              @if (canRetryIntent) {
                <div class="retryButtonCont">
                  <ion-button shape="round" color="secondary" class="retryButton" (click)="loadIntent(vm.payment.balance)">
                    Try again
                  </ion-button>
                </div>
              }
            </div>
          }
          <!-- <div *ngIf="paymentComplete">
          <ion-item>{{ paymentResult }}</ion-item>
        </div> -->
        <hr class="hrOverAdditionalInfo" />
        <div class="additionalInfo">
          <div class="content">
            <div class="legend">Additional Info</div>
            <hr />
            <p [class.dash]="vm.paymentViewModel.description.length === 0">
              {{ vm.paymentViewModel.description.length > 0 ? vm.paymentViewModel.description : '-' }}
            </p>
          </div>
        </div>
        <hr class="hrOverAuthor" />
        <div class="author">
          <app-publisher-avatar class="ion-float-left" [publisher]="vm.paymentViewModel.contact"></app-publisher-avatar>
          <p>
            <span>
              Requested by
              {{
              vm.paymentViewModel.contact && vm.paymentViewModel.contact.displayName
              ? vm.paymentViewModel.contact.displayName
              : 'Unknown'
              }}
            </span>
          </p>
        </div>
        <hr class="hrBelowAuthor" />
      </ion-grid>
    </ng-template>
    <ng-template #errorTemplate>
      <div class="errorCont">
        <div class="retryErrorCont">
          @if (vm.firstLoadErrorType === 'noInternet') {
            <p class="retryErrorText">
              We weren't able to load the payment request because it looks like you're offline. <br /><br />
              Please check your wifi or mobile data connection and try again later.
            </p>
          }
          @if (vm.firstLoadErrorType === 'somethingWrong') {
            <p class="retryErrorText">
              We weren't able to load the payment request. <br /><br />Please try again later.
            </p>
          }
          @if (vm.firstLoadErrorType === 'notFound') {
            <p class="retryErrorText">
              The payment request isn't currently available, or may no longer exist. <br /><br />Please try again later.
            </p>
          }
        </div>
        <div class="retryButtonCont">
          <ion-button color="secondary" class="ph-btn retryButton" (click)="retryLoad()"> Try again </ion-button>
        </div>
      </div>
    </ng-template>
    <ng-template #loadingTemplate>
      <div class="loadingCont">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Loading Payment Request...</p>
      </div>
    </ng-template>
  </ion-content>
}
}
